import ElixirInstall from "../../../../contents/docs/integrate/_snippets/install-elixir.mdx";
import ElixirSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-elixir.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import ElixirFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-elixir.mdx";
import * as React from 'react';
export default {
  ElixirInstall,
  ElixirSendEvents,
  FeatureFlagsLibsIntro,
  ElixirFeatureFlagsCode,
  React
};